// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#agencies-list{width:60%;text-align:center}.text-title-green{color:#24a285!important;font-size:1.8em!important;text-align:center!important;padding:25px 15px!important}.timeslotSelectorItem{display:flex;justify-content:center;align-items:center}input#date-picker{text-align:center}@media only screen and (min-device-width:320px) and (max-device-width:480px){.text-title-green{font-size:1.25rem!important}#agencies-list{width:100%;text-align:center}}", ""]);
// Exports
module.exports = exports;
